import React from 'react';


import * as searchBarConstants from './searchBarConstants';
import * as styleUtils from '../../../utils/styleUtils';

import TextInput from '../../global/Form/Input/TextInput';
import ValidatingForm from '../../global/Form/ValidatingForm';
import {Button} from '../../global/Button';
import {ContentDepartmentSelect} from '../../contexts/Content';
import {Icon} from '../../global/Icon';
import {inputConstants} from '../../global/Form/Input';


import styles from './SearchBar.scss';


function SearchBar({department, doAllowReset, doShowDepartments, onSearch, text}) {

    const doSearch = form => {
        onSearch(form.getData());
    };

    const onReset = form => {

        const resetData = {
            department: 'all',
            text: null
        };
        form.setData(resetData);
        onSearch(resetData);
    };

    return (
        <ValidatingForm
            data={
                {
                    department,
                    text
                }
            }
            doSyncData={true}
            validationSchema={searchBarConstants.SCHEMA_SEARCH_BAR}
        >
            {({form}) => {

                return (
                    <div
                        className={styleUtils.toClasses(styles.searchBar, 'row')}
                        onKeyUp={event => {
                            if (event.target.type === 'text' && event.key === 'Enter' && !form.hasErrors()) {
                                doSearch(form);
                            }
                        }}
                    >

                        {doShowDepartments && (
                            <ContentDepartmentSelect
                                className={'col-2'}
                                department={form.getData('department')}
                                onChange={department => form.setData({department})}
                            />
                        )}

                        <div className={styleUtils.toClasses(styles.inputBox, doShowDepartments ? 'col-10' : 'col-12')}>

                            <TextInput
                                autocomplete={inputConstants.AUTOCOMPLETE_OFF}
                                isDisabled={false}
                                maxLength={200}
                                name={'searchText'}
                                onChange={text => form.setData({text})}
                                type={inputConstants.TYPE_TEXT}
                                value={form.getData('text')}
                            />

                            {doAllowReset && (
                                <a
                                    className={
                                        styleUtils.toClasses(
                                            styles.reset,
                                            !form.isModified() ? styles.unavailable : null
                                        )
                                    }
                                    onClick={event => {

                                        event.stopPropagation();
                                        event.preventDefault();

                                        if (!form.isModified()) {

                                            return;
                                        }

                                        onReset(form);
                                    }}
                                >
                                    <Icon icon={'icon-error-circle'}/>
                                </a>
                            )}

                            <div className={styles.buttonBox}>
                                <Button
                                    iconStart={<Icon icon={'icon-search'}/>}
                                    isDisabled={form.hasErrors()}
                                    labelI18n={'global.label.text.search'}
                                    onClick={() => doSearch(form)}
                                />
                            </div>

                        </div>

                    </div>
                );
            }}
        </ValidatingForm>
    );
}


SearchBar.propTypes = {
    ...searchBarConstants.SHAPE_SEARCH_BAR
};


SearchBar.defaultProps = {
    department: 'all',
    doAllowReset: false,
    doShowDepartments: true
};


export default SearchBar;
